/* eslint-disable no-console */
import {Table} from 'antd';
import React from 'react';

import {
  AverageKey,
  AverageLabel
} from '../../Forms/Constants/IP/AverageKeyLabel';

const CapGoodsSupplier: React.FC<{dataSource: any; suppliers: any}> = ({
  dataSource,
  suppliers
}) => {
  const columns: any = [
    {
      title: AverageLabel.SUPPLIER_NAME,
      dataIndex: AverageKey.SUPPLIER_NAME,
      width: 120,
      render: (value: any) => {
        return (
          <>
            {
              suppliers?.find((item: any) => {
                return item?.value === value;
              })?.label
            }
          </>
        );
      }
    }
  ];

  return (
    <Table
      bordered={false}
      columns={columns}
      dataSource={dataSource}
      pagination={{pageSize: 50}}
      scroll={{y: 240}}
      rowKey={AverageKey.SUPPLIER_NAME}
      // tableLayout="auto"
    />
  );
};

export default CapGoodsSupplier;
